import { LinkTo } from '@ember/routing';
import Tile from '../tile';
import Svg from 'tio-employee/components/svg';
import { t } from 'ember-intl';

<template>
  <LinkTo @route="authenticated.repaying-student-debt.coaching">
    <Tile @headerText={{t "dashboard_tiles.student_loan_coaches"}}>
      <:description>
        {{t "dashboard_tiles.schedule_expert_call"}}
      </:description>
      <:image>
        <Svg
          @name="woman-on-laptop-working"
          width="100%"
          height="100%"
          role="img"
          aria-label={{t "svg.woman_on_laptop_working"}}
        />
      </:image>
    </Tile>
  </LinkTo>
</template>
